import { Transaction } from 'src/app/models/transaction';
import {
  STATUS_OPTIONS,
  StatusKind,
  dateValue,
  formatAmount,
  statusKind,
  statusLabel,
} from './tx-table.utils';

export abstract class TxTableBase {
  rows: Transaction[] = [];
  filteredData: Transaction[] = [];
  tickets: any[] = [];

  searchQuery = '';
  statusFilter: StatusKind | '' = '';
  ticketFilter = '';
  showFilters = false;

  page = 1;
  readonly pageSize = 10;

  readonly statusOptions = STATUS_OPTIONS;
  readonly statusKind = statusKind;
  readonly statusLabel = statusLabel;
  readonly formatAmount = formatAmount;

  protected setRows(rows: Transaction[]): void {
    this.rows = [...rows].sort((a, b) => dateValue(b.date) - dateValue(a.date));
    this.applyFilters();
  }

  ticketLabel(id: any): string {
    const ticket = this.tickets.find((t: any) => t.id == id);
    return ticket ? ticket.label : 'Titre non trouvé';
  }

  get ticketOptions(): { id: string; label: string }[] {
    const ids = Array.from(new Set(this.rows.map((r) => String(r.ticketId))));
    return ids.map((id) => ({ id, label: this.ticketLabel(id) }));
  }

  get activeFilterCount(): number {
    return (this.statusFilter ? 1 : 0) + (this.ticketFilter ? 1 : 0);
  }

  onSearch(event: Event): void {
    this.searchQuery = (event.target as HTMLInputElement).value;
    this.applyFilters();
  }

  resetFilters(): void {
    this.statusFilter = '';
    this.ticketFilter = '';
    this.applyFilters();
  }

  applyFilters(): void {
    const q = this.searchQuery.trim().toLowerCase();
    this.filteredData = this.rows.filter((item) => {
      if (this.statusFilter && statusKind(item.status) !== this.statusFilter) return false;
      if (this.ticketFilter && String(item.ticketId) !== this.ticketFilter) return false;
      if (!q) return true;
      const haystack = [
        item.id,
        this.ticketLabel(item.ticketId),
        item.from,
        item.merchantKidId,
        item.date,
        item.amount,
        item.status,
        statusLabel(item.status),
      ]
        .filter((v) => v !== undefined && v !== null)
        .join(' ')
        .toLowerCase();
      return haystack.includes(q);
    });
    this.page = 1;
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.filteredData.length / this.pageSize));
  }

  get pages(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  get pagedData(): Transaction[] {
    const start = (this.page - 1) * this.pageSize;
    return this.filteredData.slice(start, start + this.pageSize);
  }

  get rangeStart(): number {
    return this.filteredData.length ? (this.page - 1) * this.pageSize + 1 : 0;
  }

  get rangeEnd(): number {
    return Math.min(this.page * this.pageSize, this.filteredData.length);
  }

  goTo(page: number): void {
    this.page = Math.min(Math.max(1, page), this.totalPages);
  }

  trackById(_: number, row: Transaction): string {
    return row.id;
  }
}